module.exports = __webpack_public_path__ + "static/media/smartsound_CINEMATIC_HIT_High_Metal_Click_02.ba30057c.wav";